module.exports = require("./ConfigWrapper").create(require("./configs/" + process.env.VUE_APP_TARGET_PROJECT + "Config.js").default);
